class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    // const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    // container.innerHTML = count;
    // container.classList.remove('loading');
    if (containerDesktop) {
      // containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    
    // Sync active classes after filters are rendered - check from the rendered HTML
    setTimeout(() => {
      FacetFiltersForm.syncSubmenuActiveClassesFromRendered(parsedHTML);
      document.dispatchEvent(new CustomEvent('collection:rendered'));
    }, 500);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    
    // Sync active classes to .product-type-submenu after filters are rendered
    // Use a longer delay to ensure all filters are fully updated in the DOM
    setTimeout(() => {
      FacetFiltersForm.syncSubmenuActiveClasses();
    }, 1500);
  }
  
  static syncSubmenuActiveClassesFromRendered(html) {
    // Get checked inputs from the rendered HTML (this is the source of truth)
    const checkedInputs = html.querySelectorAll(
      '#FacetFiltersForm input[type="checkbox"]:checked, ' +
      '#FacetFiltersFormMobile input[type="checkbox"]:checked, ' +
      '#FacetFiltersForm input[type="radio"]:checked, ' +
      '#FacetFiltersFormMobile input[type="radio"]:checked'
    );
    
    // Collect all active data-value-name values from checked inputs
    const activeDataValueNames = new Set();
    const activeFilterData = [];
    
    if (checkedInputs.length > 0) {
      console.log('Active filter labels from rendered HTML:');
      checkedInputs.forEach((input, index) => {
        const label = input.closest('.mobile-facets__label') || 
                      html.querySelector(`label[for="${input.id}"]`);
        
        if (label) {
          const labelText = label.textContent?.trim() || 'No text';
          const dataValueName = label.getAttribute('data-value-name');
          
          console.log(`${index + 1}. ${labelText} (data-value-name: ${dataValueName})`);
          
          if (dataValueName) {
            activeDataValueNames.add(dataValueName);
            activeFilterData.push({
              text: labelText,
              dataValueName: dataValueName
            });
          }
        }
      });
    } else {
      console.log('No active filter labels found in rendered HTML');
    }
    
    // Get all labels in top type/size filter bars
    const submenuLabels = document.querySelectorAll(
      '.product-type-submenu .mobile-facets__label[data-value-name], ' +
      '.product-type-submenu .collection-size-filters__label[data-value-name], ' +
      '.product-size-submenu .collection-size-filters__label[data-value-name]'
    );
    
    // First, remove all active classes from submenu labels
    submenuLabels.forEach((submenuLabel) => {
      submenuLabel.classList.remove('active');
    });
    console.log('Removed all active classes from .product-type-submenu labels');
    
    // Then, add active class only to matching ones
    submenuLabels.forEach((submenuLabel) => {
      const submenuDataValueName = submenuLabel.getAttribute('data-value-name');
      
      // If this label's data-value-name matches an active one, add active class
      if (submenuDataValueName && activeDataValueNames.has(submenuDataValueName)) {
        submenuLabel.classList.add('active');
        console.log(`Added active class to matching label in .product-type-submenu: ${submenuLabel.textContent?.trim()}`);
      }
    });
  }
  
  static syncSubmenuActiveClasses() {
    // Get checked inputs from the current DOM (fallback method)
    const checkedInputs = document.querySelectorAll(
      '#FacetFiltersForm input[type="checkbox"]:checked, ' +
      '#FacetFiltersFormMobile input[type="checkbox"]:checked, ' +
      '#FacetFiltersForm input[type="radio"]:checked, ' +
      '#FacetFiltersFormMobile input[type="radio"]:checked'
    );
    
    // Collect all active data-value-name values from checked inputs
    const activeDataValueNames = new Set();
    const activeFilterData = [];
    
    if (checkedInputs.length > 0) {
      console.log('Active filter labels from DOM:');
      checkedInputs.forEach((input, index) => {
        const label = input.closest('.mobile-facets__label') || 
                      document.querySelector(`label[for="${input.id}"]`);
        
        if (label) {
          const labelText = label.textContent?.trim() || 'No text';
          const dataValueName = label.getAttribute('data-value-name');
          
          console.log(`${index + 1}. ${labelText} (data-value-name: ${dataValueName})`);
          
          if (dataValueName) {
            activeDataValueNames.add(dataValueName);
            activeFilterData.push({
              text: labelText,
              dataValueName: dataValueName
            });
          }
        }
      });
    } else {
      console.log('No active filter labels found in DOM');
    }
    
    // Get all labels in top type/size filter bars
    const submenuLabels = document.querySelectorAll(
      '.product-type-submenu .mobile-facets__label[data-value-name], ' +
      '.product-type-submenu .collection-size-filters__label[data-value-name], ' +
      '.product-size-submenu .collection-size-filters__label[data-value-name]'
    );
    
    // First, remove all active classes from submenu labels
    submenuLabels.forEach((submenuLabel) => {
      submenuLabel.classList.remove('active');
    });
    console.log('Removed all active classes from .product-type-submenu labels');
    
    // Then, add active class only to matching ones
    submenuLabels.forEach((submenuLabel) => {
      const submenuDataValueName = submenuLabel.getAttribute('data-value-name');
      
      // If this label's data-value-name matches an active one, add active class
      if (submenuDataValueName && activeDataValueNames.has(submenuDataValueName)) {
        submenuLabel.classList.add('active');
        console.log(`Added active class to matching label in .product-type-submenu: ${submenuLabel.textContent?.trim()}`);
      }
    });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  updateCaracteristicasFilters(url) {
    console.log('Updating caracteristicas filters with URL:', url);
    
    // Parse the URL to get current filter parameters
    const urlParams = new URLSearchParams(url);
    const caracteristicasValues = urlParams.getAll('filter.p.m.thinkingmu.characteristics');
    
    // Find all caracteristicas checkboxes in the submenu
    const caracteristicasForm = document.querySelector('#CaracteristicasFiltersForm');
    if (!caracteristicasForm) {
      console.log('Caracteristicas form not found');
      return;
    }
    
    const caracteristicasInputs = caracteristicasForm.querySelectorAll('input[name="filter.p.m.thinkingmu.characteristics"]');
    
    // Update each checkbox based on URL parameters
    caracteristicasInputs.forEach((input) => {
      const inputValue = input.getAttribute('value');
      const shouldBeChecked = caracteristicasValues.includes(inputValue);
      
      input.checked = shouldBeChecked;
      
      // Update active class on label
      const label = input.closest('.mobile-facets__label');
      if (label) {
        if (shouldBeChecked) {
          label.classList.add('active');
        } else {
          label.classList.remove('active');
        }
      }
      
      console.log(`Updated caracteristicas filter "${inputValue}": checked = ${shouldBeChecked}`);
    });
    
    console.log('Caracteristicas filters updated successfully');
  }



  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    console.log('Filter action triggered:', event.target);
    
    // Ensure mobile availability filter is enabled via its label when any filter/sort is applied
    const availabilityMobileInput = document.querySelector(
      'input#Filter-filter\\.v\\.availability-mobile-1'
    );
    const availabilityMobileLabel = document.querySelector(
      'label[for="Filter-filter.v.availability-mobile-1"]'
    );

    if (availabilityMobileInput && availabilityMobileLabel && !availabilityMobileInput.checked) {
      availabilityMobileLabel.click();
    }
    
    // Update caracteristicas filters after a delay to allow URL to update
    setTimeout(() => {
      this.updateCaracteristicasFilters(window.location.search.slice(1));
    }, 100);
    
    // Sync active classes to .product-type-submenu after filter update
    // Use longer delay to ensure filters are fully rendered
    setTimeout(() => {
      FacetFiltersForm.syncSubmenuActiveClasses();
    }, 1500);
    
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    console.log('Active filter removed:', event.target);
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    // Update caracteristicas filters after removing active filter
    this.updateCaracteristicasFilters(url);
    
    FacetFiltersForm.renderPage(url);
    
    // Sync will be handled in renderActiveFacets after page renders
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    
    // Get the removed filter value for alert before removing
    let removedFilterValue = 'Filter';
    const link = this.querySelector('a');
    
    if (link) {
      // Try to get filter name from the link text
      const linkText = link.textContent?.trim() || link.querySelector('span')?.textContent?.trim();
      if (linkText) {
        // Remove "×" or close icon text if present, and clean up
        removedFilterValue = linkText.replace(/×|close|remove|Clear filter/gi, '').trim();
        // Remove extra whitespace
        removedFilterValue = removedFilterValue.replace(/\s+/g, ' ').trim();
      }
      
      // Try to get from the active facets button inner text
      const buttonInner = link.querySelector('.active-facets__button-inner');
      if (buttonInner) {
        const buttonText = buttonInner.textContent?.trim();
        if (buttonText) {
          // Remove close icon and clean up
          removedFilterValue = buttonText.replace(/×|close|remove|Clear filter/gi, '').trim();
          removedFilterValue = removedFilterValue.replace(/\s+/g, ' ').trim();
        }
      }
    }
    
    // Alert when filter is removed
    alert('Filter removed: ' + removedFilterValue);
    
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
